export const colors: any = {
  primary: {
    // base: "#7DD3FC",
    base: "#60A5FA",
    100: "#F5DACB",
    200: "#FDB38A",
    300: "#F78849",
    400: "#FD7224",
    500: "#DD631F",
    600: "#9E4614",
    700: "#481E06",
    800: "#7DD3FC",
  },
  secondary: {
    base: "#E8B140",
    100: "#BDE2FE",
    200: "#8AC7F6",
    300: "#39A5F4",
    400: "#0B87E2",
    500: "#016CBA",
    600: "#064D81",
    700: "#02253E",
  },
  danger: {
    100: "#FFD6D6",
    200: "#F48585",
    300: "#FC4C4C",
    400: "#F22828",
    500: "#A61515",
    600: "#870C0C",
    700: "#360404",
  },
  success: {
    100: "#B0EEC5",
    200: "#4DD97D",
    300: "#1EA44C",
    400: "#069436",
    500: "#06782D",
    600: "#014719",
    700: "#00250D",
  },
  gray: {
    base: "#7A7C83",
    100: "#F0F0F1",
    200: "#C7C8CB",
    300: "#A0A1A7",
    400: "#7A7C83",
    500: "#57595E",
    600: "#37383B",
    700: "#191A1C",
    800: "#475569",
    900: "#94A3B8",
  },
  neutralShades: {
    100: "#FFFFFF",
    90: "rgba(255, 255, 255, 0.90)",
    80: "rgba(255, 255, 255, 0.80)",
    70: "rgba(255, 255, 255, 0.70)",
    50: "rgba(255, 255, 255, 0.50)",
    25: "rgba(255, 255, 255, 0.25)",
    10: "rgba(255, 255, 255, 0.10)",
  },
  tertiary: {
    base: "#000000",
    100: "#000000",
    200: "#000000",
    300: "#000000",
    400: "#000000",
    500: "#000000",
    600: "#000000",
    700: "#000000",
  },
  app: {
    main: "#121212",
    card: "#202022",
  },
};
